import {computed, Comment, Fragment, Text, useSlots} from 'vue'

/**
 * Helper to check if Node is empty
 */
export function vNodeIsEmpty (vnodes) {
  return vnodes.every(node => {
    if (node.type === Comment) {
      return true
    }
    if (node.type === Text && !node.children.trim()) {
      return true
    }
    if (node.type === Fragment && vNodeIsEmpty(node.children)) {
      return true
    }
    return false
  })
}

/**
 * Returns true if a slot has no content
 */
export function isEmpty(slot, props) {
  if (!slot) {
    return true
  }
  return vNodeIsEmpty(slot(props))
}

/**
 * Compo
 */
export function useEmptySlotsCheck(slotKey = 'default') {

  //Get slots
  const slots = useSlots()
  const slot = slots[slotKey]

  //Check if slot empty
  const isSlotEmpty = computed(() => !slot || isEmpty(slot))
  const emptySlots = computed(() => Object
    .keys(slots)
    .filter(key => isEmpty(slots[key]))
    .reduce((obj, key) => {
      obj[key] = true
      return obj
    }, {})
  )

  //Expose interface
  return {
    isSlotEmpty,
    emptySlots,
  }
}
